import React, {Component} from 'react'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

class TransformModules extends Component {

    render() {
        const { joinResultGroup, isLoading } = this.props;
        return (
            <>
            <TransformWrapper defaultScale={1} defaultPositionX={200} defaultPositionY={100}>
                {({ zoomIn, zoomOut, resetTransform, positionX, positionY, ...rest }) => (
                    <TransformComponent>
                        <table className="table table-outline mb-0 d-none d-sm-table" >
                            <tbody className="tbody">
                                {
                                (joinResultGroup.length > 0 && !isLoading) &&
                                <>
                                {
                                    joinResultGroup.map((row1, idx1) => (
                                        <tr key={idx1}>
                                            {
                                                row1.modules.map((row2, idx2) => (
                                                    <td key={idx2} id={row2.moduleSerialNo} onClick={() => this.props.handleClickModule(row2.title, row2.zigbee)}>
                                                        <div className="card" style={{height: "auto", width: "160px"}}>
                                                            <div className="card-header">
                                                                <h1 style={{color: "#0100FF"}}><b>{row2.title}</b></h1>
                                                            </div>
                                                            <div className={`card-body ${row2.status}`}>
                                                                입력전류: <i className="measure-value">{row2.inputCurrent.toFixed(2) * -1}</i><br/>
                                                                입력전압: <i className="measure-value">{row2.inputVoltage.toFixed(2)}</i><br/>
                                                                입력전력: <i className="measure-value">{row2.inputPower.toFixed(2) * -1}</i>
                                                            </div>
                                                            <div className={`card-footer ${row2.status}`}>
                                                                출력전류: <i className="measure-value">{row2.outputCurrent.toFixed(2) * -1}</i><br/>
                                                                출력전압: <i className="measure-value">{row2.outputVoltage.toFixed(2)}</i><br/>
                                                                출력전력: <i className="measure-value">{row2.outputPower.toFixed(2) * -1}</i>
                                                            </div>
                                                        </div>
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    ))
                                }
                                </>
                                }
                            </tbody>
                        </table>
                    </TransformComponent>
                )}
            </TransformWrapper>

            <style jsx>
                {`
                .card {
                    margin-bottom: -1rem;
                }
                table .card {
                    border-color: #39f;
                }
                .table th, .table td {
                    border-top: 0px;
                }
                .tbody {
                    zoom: 0.35;
                    background-color: mintcream;
                }
                .measure-value {
                    font-weight: bold;
                    float: right;
                }

                .state-on {
                    background-color: #FFFFFF;
                }

                @-webkit-keyframes 'state-error' {
                    0% { background: #FFFFFF; }
                    50% { background: #FFEAEA; }
                    100% { background: #FFC6C6; }
                }
                .state-error {
                    -webkit-animation-direction: alternate-reverse;
                    -webkit-animation-duration: 2.5s;
                    -webkit-animation-iteration-count: infinite;
                    -webkit-animation-name: state-error;
                    -webkit-animation-timing-function: ease;   
                }

                @-webkit-keyframes 'state-off' {
                    0% { background: #FFFFFF; }
                    50% { background: #DBDBDB; }
                    100% { background: #A5A5A5; }
                }
                .state-off {
                    -webkit-animation-direction: alternate;
                    -webkit-animation-duration: 2s;
                    -webkit-animation-iteration-count: infinite;
                    -webkit-animation-name: state-off;
                    -webkit-animation-timing-function: ease;   
                }
                
                `}
            </style>
            </>
        )
    }
}

export default TransformModules
